import GlobalStyleModal, {
  GlobalStyleModalProps,
} from './containers/GlobalStyleModal';

export default GlobalStyleModal;
export { GlobalStyleModalProps };
